module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/mini-card/mini-card.component.scss
// module id = ./src/app/modules/common-module/components/mini-card/mini-card.component.scss
// module chunks = 9